import { useRef as e, useMemo as t } from "react";
import { unstable_batchedUpdates as n } from "react-dom";
import r from "../errors/SyntheticChangeError.js";
import u from "../utils/setInputAttributes.js";
var c = ["text", "email", "tel", "search", "url"];
function o(_ref) {
  var o = _ref.init,
    i = _ref.tracking,
    a = _ref.customInputEventType,
    l = _ref.customInputEventHandler;
  var s = e({
      timeoutId: -1,
      fallbackTimeoutId: -1,
      cachedTimeoutId: -1,
      start: 0,
      end: 0
    }),
    d = e(!0),
    m = e(null),
    p = e({
      init: o,
      tracking: i,
      customInputEventType: a,
      customInputEventHandler: l
    });
  return p.current.init = o, p.current.tracking = i, p.current.customInputEventType = a, p.current.customInputEventHandler = l, t(function () {
    return function (e, t, _ref2) {
      var n = _ref2.onFocus,
        r = _ref2.onBlur,
        o = _ref2.onInput;
      return new Proxy(e, {
        set: function set(i, a, l) {
          if ("current" !== a) return !1;
          var s = null !== l && c.includes(l.type);
          if ("production" === process.env.NODE_ENV || null === l || s || console.warn("Warn: The input element type does not match one of the types: ".concat(c.join(", "), ".")), l !== e.current && (null !== e.current && (e.current.removeEventListener("focus", n), e.current.removeEventListener("blur", r), e.current.removeEventListener("input", o)), null !== l && s)) {
            var _l$_wrapperState;
            var _ref3 = (_l$_wrapperState = l._wrapperState) !== null && _l$_wrapperState !== void 0 ? _l$_wrapperState : {},
              _ref3$controlled = _ref3.controlled,
              _e = _ref3$controlled === void 0 ? !1 : _ref3$controlled,
              _ref3$initialValue = _ref3.initialValue,
              _c = _ref3$initialValue === void 0 ? "" : _ref3$initialValue,
              _i = t({
                controlled: _e,
                initialValue: l.value || _c
              });
            u(l, {
              value: _i.value
            }), document.activeElement === l && n(), l.addEventListener("focus", n), l.addEventListener("blur", r), l.addEventListener("input", o);
          }
          return i[a] = l, !0;
        }
      });
    }(m, p.current.init, {
      onFocus: function onFocus() {
        var e = m.current;
        if (null === e) return;
        var t = function t() {
          var _e$selectionStart, _e$selectionEnd;
          d.current ? (s.current.start = (_e$selectionStart = e.selectionStart) !== null && _e$selectionStart !== void 0 ? _e$selectionStart : 0, s.current.end = (_e$selectionEnd = e.selectionEnd) !== null && _e$selectionEnd !== void 0 ? _e$selectionEnd : 0, s.current.timeoutId = window.setTimeout(t)) : s.current.fallbackTimeoutId = window.setTimeout(t);
        };
        s.current.timeoutId = window.setTimeout(t);
      },
      onBlur: function onBlur() {
        window.clearTimeout(s.current.timeoutId), window.clearTimeout(s.current.fallbackTimeoutId), s.current.timeoutId = -1, s.current.fallbackTimeoutId = -1, s.current.cachedTimeoutId = -1;
      },
      onInput: function onInput(e) {
        var t = m.current;
        if (null !== t) try {
          var _t$_valueTracker$getV, _t$_valueTracker, _t$_valueTracker$getV2, _t$_valueTracker2, _t$_valueTracker2$set;
          if (s.current.cachedTimeoutId === s.current.timeoutId) throw new r("The input selection has not been updated.");
          s.current.cachedTimeoutId = s.current.timeoutId;
          var _e2 = t.value,
            _c2 = t.selectionStart,
            _o = t.selectionEnd;
          if (null === _c2 || null === _o) throw new r("The selection attributes have not been initialized.");
          var _i2 = (_t$_valueTracker$getV = (_t$_valueTracker = t._valueTracker) === null || _t$_valueTracker === void 0 ? void 0 : (_t$_valueTracker$getV2 = _t$_valueTracker.getValue) === null || _t$_valueTracker$getV2 === void 0 ? void 0 : _t$_valueTracker$getV2.call(_t$_valueTracker)) !== null && _t$_valueTracker$getV !== void 0 ? _t$_valueTracker$getV : "";
          var _a = "initial";
          if (_c2 > s.current.start ? _a = "insert" : _c2 <= s.current.start && _c2 < s.current.end ? _a = "deleteBackward" : _c2 === s.current.end && _e2.length < _i2.length && (_a = "deleteForward"), ("deleteBackward" === _a || "deleteForward" === _a) && _e2.length > _i2.length) throw new r("Input type detection error.");
          var _l = "",
            _m = "",
            v = s.current.start,
            h = s.current.end;
          switch (_a) {
            case "insert":
              _l = _e2.slice(s.current.start, _c2);
              break;
            case "deleteBackward":
            case "deleteForward":
              {
                var _t = _i2.length - _e2.length;
                v = _c2, h = _c2 + _t, _m = _i2.slice(v, h);
                break;
              }
            default:
              throw new r("The input type is undefined.");
          }
          var E = p.current.tracking({
            inputType: _a,
            previousValue: _i2,
            value: _e2,
            addedValue: _l,
            deletedValue: _m,
            changeStart: v,
            changeEnd: h,
            selectionStart: _c2,
            selectionEnd: _o
          });
          u(t, {
            value: E.value,
            selectionStart: E.selectionStart,
            selectionEnd: E.selectionEnd
          });
          var w = p.current.customInputEventHandler;
          if (w) {
            var _e3 = t.value,
              _r = t.selectionStart,
              _c3 = t.selectionEnd;
            d.current = !1, requestAnimationFrame(function () {
              u(t, {
                value: _e3,
                selectionStart: _r !== null && _r !== void 0 ? _r : _e3.length,
                selectionEnd: _c3 !== null && _c3 !== void 0 ? _c3 : _e3.length
              });
              var o = new CustomEvent(p.current.customInputEventType, {
                bubbles: !0,
                cancelable: !1,
                composed: !0,
                detail: E.__detail
              });
              t.dispatchEvent(o), n ? n(w, o) : w(o), d.current = !0;
            });
          }
          (_t$_valueTracker2 = t._valueTracker) === null || _t$_valueTracker2 === void 0 ? void 0 : (_t$_valueTracker2$set = _t$_valueTracker2.setValue) === null || _t$_valueTracker2$set === void 0 ? void 0 : _t$_valueTracker2$set.call(_t$_valueTracker2, _i2), s.current.start = E.selectionStart, s.current.end = E.selectionEnd;
        } catch (n) {
          var _ref4, _c4$__attributes$valu, _c4$__attributes, _t$_valueTracker3, _t$_valueTracker3$get, _c4$__attributes$sele, _c4$__attributes2, _c4$__attributes$sele2, _c4$__attributes3, _c4$__attributes4, _c4$__attributes5;
          var _r2 = n.name,
            _c4 = n.cause;
          if (u(t, {
            value: (_ref4 = (_c4$__attributes$valu = _c4 === null || _c4 === void 0 ? void 0 : (_c4$__attributes = _c4.__attributes) === null || _c4$__attributes === void 0 ? void 0 : _c4$__attributes.value) !== null && _c4$__attributes$valu !== void 0 ? _c4$__attributes$valu : (_t$_valueTracker3 = t._valueTracker) === null || _t$_valueTracker3 === void 0 ? void 0 : (_t$_valueTracker3$get = _t$_valueTracker3.getValue) === null || _t$_valueTracker3$get === void 0 ? void 0 : _t$_valueTracker3$get.call(_t$_valueTracker3)) !== null && _ref4 !== void 0 ? _ref4 : "",
            selectionStart: (_c4$__attributes$sele = _c4 === null || _c4 === void 0 ? void 0 : (_c4$__attributes2 = _c4.__attributes) === null || _c4$__attributes2 === void 0 ? void 0 : _c4$__attributes2.selectionStart) !== null && _c4$__attributes$sele !== void 0 ? _c4$__attributes$sele : s.current.start,
            selectionEnd: (_c4$__attributes$sele2 = _c4 === null || _c4 === void 0 ? void 0 : (_c4$__attributes3 = _c4.__attributes) === null || _c4$__attributes3 === void 0 ? void 0 : _c4$__attributes3.selectionEnd) !== null && _c4$__attributes$sele2 !== void 0 ? _c4$__attributes$sele2 : s.current.end
          }), void 0 !== (_c4 === null || _c4 === void 0 ? void 0 : (_c4$__attributes4 = _c4.__attributes) === null || _c4$__attributes4 === void 0 ? void 0 : _c4$__attributes4.selectionStart) && (s.current.start = _c4.__attributes.selectionStart), void 0 !== (_c4 === null || _c4 === void 0 ? void 0 : (_c4$__attributes5 = _c4.__attributes) === null || _c4$__attributes5 === void 0 ? void 0 : _c4$__attributes5.selectionEnd) && (s.current.end = _c4.__attributes.selectionEnd), e.preventDefault(), e.stopPropagation(), "SyntheticChangeError" !== _r2) throw n;
        }
      }
    });
  }, []);
}
export { o as default };